import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import React from "react";
import cardStyles from "../../../View/CardStyles";
import { createUseStyles } from "react-jss";
import { makeStylesFromThemeAndCustomStyles } from "../../../../../lib/StyleFunctions";
import { mergeDeepRight } from "ramda";
const ReactMarkdown = require("react-markdown/with-html");

const useStyles = (customWidgetStyle) =>
  createUseStyles(
    makeStylesFromThemeAndCustomStyles(
      (theme) =>
        mergeDeepRight(cardStyles(theme), {
          cardButton: {
            margin: "4px 8px 4px 0",
            textAlign: "left",
            "&:hover svg": {
              stroke: "white",
            },
          },
          buttonContainer: {
            display: "flex",
            alignItems: "center",
          },
          suggestionIcon: {
            marginRight: "8px",
          },
          externalLinkIcon: {
            margin: "1px 0 0 8px",
            stroke: theme.secondaryColor,
            transition: "0.3s",
          },
        }),
      customWidgetStyle
    )
  )();

export default ({
  icon,
  displayText,
  handleClick,
  customWidgetStyle,
  isExternalLink,
}) => {
  const styles = useStyles(customWidgetStyle);

  const ExternalLinkIcon = () => (
    <svg
      className={styles.externalLinkIcon}
      width="12"
      height="12"
      viewBox="0 0 12 12"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4.5 1H3C1.89543 1 1 1.89543 1 3V9C1 10.1046 1.89543 11 3 11H9C10.1046 11 11 10.1046 11 9V7.5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M7.5 1H11V4.5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M11 1L7 5"
        strokeWidth="1.2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
  return (
    <button
      className={styles.cardButton}
      onClick={handleClick}
      aria-label={displayText}
    >
      <div className={styles.buttonContainer}>
        {icon ? (
          <FontAwesomeIcon
            className={[styles.icon, styles.suggestionIcon].join(" ")}
            aria-hidden="true"
            icon={icon}
          />
        ) : null}{" "}
        <div>
          <ReactMarkdown source={displayText} />
        </div>
        {isExternalLink ? <ExternalLinkIcon /> : null}
      </div>
    </button>
  );
};
